import { render, staticRenderFns } from "./S2.vue?vue&type=template&id=2c2153af&scoped=true&"
import script from "./S2.vue?vue&type=script&lang=js&"
export * from "./S2.vue?vue&type=script&lang=js&"
import style0 from "./S2.vue?vue&type=style&index=0&id=2c2153af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2153af",
  null
  
)

export default component.exports